webpackJsonp([35783957827783],{

/***/ 155:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction) {
	    throw new Error(prefix);
	  } else {
	    throw new Error(prefix + ": " + (message || ''));
	  }
	}
	
	module.exports = invariant;


/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _postSummaryModule = __webpack_require__(102);
	
	var _postSummaryModule2 = _interopRequireDefault(_postSummaryModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var post = _ref.post;
	
	    var image = !post.frontmatter.imageUrl ? null : _react2.default.createElement("img", { src: post.frontmatter.imageUrl, alt: "post thumbnail" });
	
	    return _react2.default.createElement(
	        "div",
	        { className: _postSummaryModule2.default.post },
	        _react2.default.createElement(
	            "div",
	            { className: _postSummaryModule2.default.image },
	            image
	        ),
	        _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                "h3",
	                null,
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: post.fields.slug, className: _postSummaryModule2.default.title },
	                    post.frontmatter.title
	                )
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                post.excerpt
	            )
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _postSummaryModule = __webpack_require__(102);
	
	var _postSummaryModule2 = _interopRequireDefault(_postSummaryModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var episode = _ref.episode;
	
	    return _react2.default.createElement(
	        "div",
	        { className: _postSummaryModule2.default.post },
	        _react2.default.createElement(
	            "div",
	            { className: _postSummaryModule2.default.image },
	            _react2.default.createElement("img", { src: episode.itunes.image, alt: "episode thumbnail" })
	        ),
	        _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                "h3",
	                null,
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: episode.fields.slug, className: _postSummaryModule2.default.title },
	                    episode.title
	                )
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                episode.itunes.subtitle
	            )
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _featuredPostModule = __webpack_require__(151);
	
	var _featuredPostModule2 = _interopRequireDefault(_featuredPostModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var post = _ref.post;
	
	  var blogPost = post.post;
	
	  return _react2.default.createElement(
	    "div",
	    { className: _featuredPostModule2.default.container },
	    _react2.default.createElement(
	      "div",
	      { className: _featuredPostModule2.default.content },
	      _react2.default.createElement(
	        "h1",
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: blogPost.fields.slug, className: _featuredPostModule2.default.title },
	          blogPost.frontmatter.title
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _featuredPostModule2.default.date },
	        new Date(blogPost.frontmatter.date).toLocaleDateString()
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        blogPost.excerpt
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: blogPost.fields.slug, className: _featuredPostModule2.default.shownotes },
	        "View Full Post"
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _featuredPostModule = __webpack_require__(151);
	
	var _featuredPostModule2 = _interopRequireDefault(_featuredPostModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var episode = _ref.episode;
	
	  var post = episode.post;
	  return _react2.default.createElement(
	    "div",
	    { className: _featuredPostModule2.default.container },
	    _react2.default.createElement(
	      "div",
	      { className: _featuredPostModule2.default.content },
	      _react2.default.createElement(
	        "h1",
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: post.fields.slug, className: _featuredPostModule2.default.title },
	          post.title
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _featuredPostModule2.default.date },
	        new Date(post.pubDate).toLocaleDateString()
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _featuredPostModule2.default.player },
	        _react2.default.createElement("img", { className: _featuredPostModule2.default.image, src: post.itunes.image }),
	        _react2.default.createElement("audio", { className: _featuredPostModule2.default.audio, src: post.enclosure.url, preload: "none", controls: true })
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        post.itunes.subtitle
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: post.fields.slug, className: _featuredPostModule2.default.shownotes },
	        "Show Notes"
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EpisodeSummary = __webpack_require__(202);
	
	var _EpisodeSummary2 = _interopRequireDefault(_EpisodeSummary);
	
	var _BlogPostSummary = __webpack_require__(201);
	
	var _BlogPostSummary2 = _interopRequireDefault(_BlogPostSummary);
	
	var _postSummaryModule = __webpack_require__(102);
	
	var _postSummaryModule2 = _interopRequireDefault(_postSummaryModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var data = _ref.data,
	        posts = _ref.posts;
	
	    var episodes = data.allRssFeedItem.edges.slice(1, data.allRssFeedItem.edges.length);
	    var episodesJsx = episodes.map(function (episode, i) {
	        return _react2.default.createElement(_EpisodeSummary2.default, { episode: episode.node, key: i });
	    });
	
	    var postsMinusFirst = posts.slice(1, posts.length);
	    var postsJsx = postsMinusFirst.map(function (post, i) {
	        if (post.type === "rss") {
	            return _react2.default.createElement(_EpisodeSummary2.default, { episode: post.post, key: i });
	        } else if (post.type === "blog") {
	            return _react2.default.createElement(_BlogPostSummary2.default, { post: post.post, key: i });
	        }
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: _postSummaryModule2.default.content },
	        postsJsx
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FeaturedEpisode = __webpack_require__(204);
	
	var _FeaturedEpisode2 = _interopRequireDefault(_FeaturedEpisode);
	
	var _FeaturedBlogPost = __webpack_require__(203);
	
	var _FeaturedBlogPost2 = _interopRequireDefault(_FeaturedBlogPost);
	
	var _PostSummaryList = __webpack_require__(206);
	
	var _PostSummaryList2 = _interopRequireDefault(_PostSummaryList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var rssEpisodes = data.allRssFeedItem.edges.map(function (edge) {
	    return {
	      type: "rss",
	      date: edge.node.pubDate,
	      post: edge.node
	    };
	  });
	
	  var blogPosts = data.allMarkdownRemark.edges.map(function (edge) {
	    return {
	      type: "blog",
	      date: edge.node.frontmatter.date,
	      post: edge.node
	    };
	  });
	
	  var allPostsSorted = [].concat(rssEpisodes, blogPosts).sort(function (a, b) {
	    return new Date(b.date) - new Date(a.date);
	  });
	
	  var featuredPostJsx = void 0;
	  var featuredPost = allPostsSorted[0];
	  if (featuredPost.type === "rss") {
	    featuredPostJsx = _react2.default.createElement(_FeaturedEpisode2.default, { episode: allPostsSorted[0] });
	  } else if (featuredPost.type === "blog") {
	    featuredPostJsx = _react2.default.createElement(_FeaturedBlogPost2.default, { post: allPostsSorted[0] });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    featuredPostJsx,
	    _react2.default.createElement(_PostSummaryList2.default, { data: data, posts: allPostsSorted })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 151:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-styles----featured-post-module---container---2PCCg","content":"src-styles----featured-post-module---content---3dGRf","title":"src-styles----featured-post-module---title---3xkUO","player":"src-styles----featured-post-module---player---3Z8-8","image":"src-styles----featured-post-module---image---xdnQs","audio":"src-styles----featured-post-module---audio---2fAu5","shownotes":"src-styles----featured-post-module---shownotes---3mN_B","date":"src-styles----featured-post-module---date---3YWZP"};

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"src-styles----post-summary-module---content---22PCM","post":"src-styles----post-summary-module---post---1hnAZ","title":"src-styles----post-summary-module---title---1uA1G","image":"src-styles----post-summary-module---image---ltrTv"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-7d5102d1e62ad1a1b828.js